import React from "react"
import { Button, TextTag } from "../../atoms"
import "./ChooseRestaurant.scss"
import {
  NO_RESTAURANT_OPEN,
  NOTIFY_OPEN,
  NOTIFY_WHEN_RESTAURANTS_OPEN,
  TRY_CHANGING_YOUR_LOCATION,
} from "../../constants/messages"
import { connect } from "react-redux"
import { FirebaseContext } from "../../firebase"
import { notifyWhenRestaurantsOpen } from "../../redux/actionCreators/planDinnner"
import _ from "../../utils/lodashUtils"

const RestaurantsMatchedHeader = props => {
  const { user } = props
  const { dateState, partnerState } = React.useContext(FirebaseContext)
  const notifyMessage = _.get(dateState, "notifyRestaurants")
  const notifyMe = () => {
    //api to notify user and partner when restaurants open
    props.notifyWhenRestaurantsOpen()
  }
  const partnerName = _.get(partnerState, "userDetails.display_name", "Partner")
  return (
    <div id="ChooseRestaurant">
      <div id="dinnerPlanSection">
        <div id="dinnerPlan">
          <div id="dinnerPlanHeading">
            <TextTag textType="sectionTextPrimary">
              {NO_RESTAURANT_OPEN(props.restaurantsCount)}
            </TextTag>
          </div>
          <div className="dinner-plan-sub-heading">
            <TextTag textType="default">
              {TRY_CHANGING_YOUR_LOCATION(partnerName)}
            </TextTag>
          </div>
          <div id="dinnerPlanInput">
            {notifyMessage || _.get(user, "is_subscribed") ? (
              <TextTag textType="sectionTextSecondary">
                {NOTIFY_WHEN_RESTAURANTS_OPEN}
              </TextTag>
            ) : (
              <Button btnType="primary" onClick={notifyMe}>
                {NOTIFY_OPEN}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  const {
    auth: { user },
  } = state
  return {
    user,
  }
}
export default connect(mapStateToProps, { notifyWhenRestaurantsOpen })(
  RestaurantsMatchedHeader
)
